class ProductStitcher extends HTMLElement {
    constructor() {
        super();

        this.selectors = {
            productInfo: "[js-hb-main-product]",
            productReviews: "[js-product-review]",
            objectImageWithText: "[js-object-image-with-text]",
            objectTableColumn: "[js-object-table-column]",
            objectOverlayItem: "[js-object-overlay-item]",
            sizeGuide: "[js-size-guide]",
            stitcherItem: "[js-stitcher-item]"
        };

        this.sections = {

            mainProduct: {
                element: document.querySelector(this.selectors.productInfo),
                selector: this.selectors.productInfo,
                initEvents: ["size-guide:init", "mainProductSectionMarquee:init"]
            },
             productReviews: {
                 element: document.querySelector(this.selectors.productReviews),
                 selector: this.selectors.productReviews
             },
             objectImageWithText: {
                 element: document.querySelector(this.selectors.objectImageWithText),
                 selector: this.selectors.objectImageWithText
             },
             objectTableColumn: {
                 element: document.querySelector(this.selectors.objectTableColumn),
                 selector: this.selectors.objectTableColumn
             },
             objectOverlayItem: {
                 element: document.querySelector(this.selectors.objectOverlayItem),
                 selector: this.selectors.objectOverlayItem
             },
             sizeGuide: {
                 element: document.querySelector(this.selectors.sizeGuide),
                 selector: this.selectors.sizeGuide,
                 initEvents: ["size-guide:init", "optiscroll:init"]
             }
        };

        this.stitcherItems = this.querySelectorAll(this.selectors.stitcherItem);

        this.init();
    }

    init() {
        // this.stitcherItems.forEach(stitcherItem =>
        //     stitcherItem.addEventListener("click", this.renderSectionFromFetch.bind(this))
        // );
    }

    renderSectionFromFetch(evt) {
        evt.preventDefault();
        const { currentTarget } = evt;
        const handle = currentTarget.getAttribute("data-product-handle");
        const variantsJson = JSON.parse(currentTarget.querySelector("[js-variants-json]").textContent);
        const current_variant = variantsJson.find( variant => variant.option1 === localStorage.getItem("selected-option"));

        this.updateLoading();
        Object.values(this.sections).forEach(({ element, selector, initEvents = [] }) => {

            element && this.renderSection(handle, element, selector, current_variant, ...initEvents);
        });
    }

    updateURLHash(handle) {
        const url = `/products/${handle}`;
        window.history.replaceState({}, '', url);
    }

    updateLoading() {
        this.sections.mainProduct.element.classList.add("section--loading");
    }

    renderSection(handle, container, selector, current_variant, ...initEvents) {
        // const url = current_variant ? `/products/${handle}?variant=${current_variant.id}&section_id=${container.getAttribute("data-section")}` :  `/products/${handle}?section_id=${container.getAttribute("data-section")}`;
        // this.ajaxSection(url, container, selector, handle, initEvents);
        let url = current_variant ? `/products/${handle}?variant=${current_variant.id}&section_id=${container.getAttribute("data-section")}` :  `/products/${handle}?section_id=${container.getAttribute("data-section")}`;

        const customTemplate = document.body.classList[0]?.split('template-')?.pop();

        if (customTemplate) {

            url = `${url}&view=${customTemplate}`;

        }
    }

    ajaxSection(url, container, selector, handle, initEvents = []) {
        fetch(url)
            .then(response => response.text())

            .then(html => {
                const ajaxContainer = new DOMParser()
                    .parseFromString(html, 'text/html')
                    .querySelector(selector);

                if (ajaxContainer) {
                    selector === this.selectors.productInfo
                    ? container.outerHTML = ajaxContainer.outerHTML
                    : container.innerHTML = ajaxContainer.innerHTML
                }

                if(selector === this.selectors.productInfo) {
                    window.Shopify.theme.sections.registered.product(document.querySelector('[data-section-type="product"]'));
                    document.querySelector("title").textContent = document.querySelector("[js-page-title]")?.getAttribute("data-page-title");
                    document.querySelector("meta[name='description']").content = document.querySelector("[js-page-title]")?.getAttribute("data-page-description");
                    timesactScriptNew(jQuery191)
                }

                initEvents.forEach(eventName => document.dispatchEvent(new CustomEvent(eventName)));
                selector === this.selectors.objectTableColumn || selector === this.selectors.sizeGuide ||  selector === this.selectors.objectImageWithText || selector === this.selectors.objectOverlayItem ;
                selector === this.selectors.productReviews ? yotpo.initWidgets() : null;
                selector === this.selectors.productInfo ? yotpo.initWidgets() : null;
                this.updateURLHash(handle);
            })
            .catch(err => {
                console.log(err)
            })
    }
}

customElements.define('product-stitcher', ProductStitcher);

// Swaps the PDP to another color's product in place (no page reload) when a stitcher swatch is clicked
(() => {
    const mainSel = '[id^="shopify-section-template--"][id$="__main"]';

    // Sections outside main whose content differs per color and must also be swapped on color change
    const colorSections = ['product_object_image_text_new_', 'product_review_new_', 'sticky_atc_'];
    const findColorSection = (root, type) => root.querySelector(`[id^="shopify-section-template--"][id*="__${type}"]`);
    const idle = window.requestIdleCallback || (cb => setTimeout(cb, 300));

    // Set up cache for color content (enables prefetching and faster switching back and forth)
    const cache = new Map();
    const fetchText = (url, priority = 'high') => {
        const hit = cache.get(url);
        if (hit && Date.now() - hit.at < 300000) return hit.text;
        const text = fetch(url, { priority }).then(res => {
            if (!res.ok) throw new Error(res.status);
            return res.text();
        });
        text.catch(() => cache.delete(url));
        cache.forEach((v, k) => Date.now() - v.at >= 300000 && cache.delete(k));
        cache.set(url, { at: Date.now(), text });
        return text;
    };

    // Helper to copy the current page's query params (e.g. UTMs) over to the target URL
    const withParams = url => {
        const target = new URL(url, location.origin);
        new URLSearchParams(location.search).forEach((v, k) => target.searchParams.has(k) || target.searchParams.set(k, v));
        return target;
    };
    const landing = document.querySelector('[js-hb-main-product]');

    // Main section ID per product template suffix
    const mainIds = new Map();
    // For template suffixes that do not match the current page, we need to do a full-page fetch to learn its main section ID
    // This map tracks which templates we're currently waiting to "learn" its main section ID
    const learning = new Map();

    // Eko gallery assets, captured from any page that has them so they can be loaded on demand
    let ekoTags = [];
    // Records the main section ID and any Eko assets found in a fetched or current document in mainIds
    const remember = doc => {
        const main = doc.querySelector(mainSel);
        const suffix = main?.querySelector('[js-hb-main-product]')?.dataset.templateSuffix;
        if (suffix !== undefined) mainIds.set(suffix, main.id.replace('shopify-section-', ''));
        const tags = doc.querySelectorAll('#eko-gallery-script, link[href*="eko-gallery.css"]');
        if (tags.length) ekoTags = [...tags].map(tag => document.importNode(tag));
    };
    // now run on the current page
    remember(document);

    // Uses the Section Rendering API when the template's main section ID is known; otherwise the full page.
    const requestUrl = (target, suffix) => {
        const main = mainIds.get(suffix);
        if (main === undefined || cache.has(target.href)) return target.href;
        const ids = [main, ...colorSections.map(t => findColorSection(document, t)?.id.replace('shopify-section-', ''))];
        const url = new URL(target);
        url.searchParams.set('sections', ids.filter(Boolean).join(','));
        return url.href;
    };
    // Section responses are JSON maps of section ID to HTML; join them into one document.
    const parse = (text, full) => new DOMParser().parseFromString(full ? text : Object.values(JSON.parse(text)).join(''), 'text/html');

    const preloaded = new Set();
    // Warms the cache for a swatch's product; with `images`, also preloads its first two gallery images.
    function prefetch(anchor, images) {
        const url = window.hbSwatchUrl?.(anchor);
        if (!url) return Promise.resolve();
        const suffix = anchor.dataset.templateSuffix;
        // If the main section ID is not yet known, wait until it is, so the cheaper sections request is used
        if (learning.has(suffix)) return learning.get(suffix).then(() => prefetch(anchor, images));
        const target = withParams(url);
        const request = requestUrl(target, suffix);
        const full = request === target.href;
        const done = fetchText(request, 'low').then(text => {
            // Section responses only need parsing when preloading images; full pages are always parsed to learn IDs.
            if (!full && (!images || preloaded.has(request))) return;
            const doc = parse(text, full);
            remember(doc);
            if (!images || preloaded.has(request)) return;
            preloaded.add(request);
            [...doc.querySelectorAll('[data-product-media-wrapper] img, .eko-carousel img')].slice(0, 2).forEach(img => {
                const pre = new Image();
                if (!img.getAttribute('srcset')) return void (pre.src = img.getAttribute('src'));
                pre.sizes = img.getAttribute('sizes') || '';
                pre.srcset = img.getAttribute('srcset');
            });
        }).catch(() => {});
        if (full) learning.set(suffix, done.finally(() => learning.delete(suffix)));
        return done;
    }

    let prefetchRun = 0;
    // Prefetches every other visible swatch after load, 5 at a time; a newer run cancels an older one.
    function prefetchAll() {
        if (document.readyState !== 'complete') return;
        const run = ++prefetchRun;
        const anchors = [...document.querySelectorAll('a.url_var_anchors:not([hidden])')].filter(a => !a.querySelector('.stitcher-item.active'));
        const next = () => {
            const anchor = anchors.shift();
            if (anchor && run === prefetchRun) prefetch(anchor, false).then(next);
        };
        idle(() => [1, 2, 3, 4, 5].forEach(next));
    }
    window.addEventListener('load', prefetchAll);
    document.addEventListener('mainProductSectionMarquee:init', prefetchAll);
    // Hover/touch signals likely intent, so also preload that swatch's images.
    document.addEventListener('pointerover', e => {
        const anchor = e.pointerType === 'mouse' && e.target.closest?.('a.url_var_anchors');
        if (anchor) prefetch(anchor, true);
    });
    document.addEventListener('touchstart', e => {
        const anchor = e.target.closest?.('a.url_var_anchors');
        if (anchor) prefetch(anchor, true);
    }, { passive: true });

    const cloneScript = old => {
        const s = document.createElement('script');
        [...old.attributes].forEach(a => s.setAttribute(a.name, a.value));
        s.textContent = old.textContent;
        return s;
    };

    // Initializes the Eko gallery in the new section, loading its script first if this page never had it
    async function startEko(fresh) {
        const block = fresh.querySelector('.eko-gallery-block-container');
        if (!block) return;
        block.querySelectorAll('script').forEach(old => old.replaceWith(cloneScript(old)));
        if (!window.eko?.gallery?.init) {
            const tag = ekoTags.find(t => t.tagName === 'SCRIPT');
            if (!tag) throw new Error('eko script missing');
            ekoTags.filter(t => t.tagName === 'LINK').forEach(l => document.head.append(l.cloneNode()));
            await new Promise((resolve, reject) => {
                const s = cloneScript(tag);
                s.onload = resolve;
                s.onerror = reject;
                document.head.append(s);
            });
        }
        window.eko.gallery.init();
    }

    let latest = 0;
    let requested = null;
    const suffixes = new Map(landing ? [[landing.dataset.url, landing.dataset.templateSuffix]] : []);

    async function switchColor(url, suffix, push) {
        const call = ++latest;
        const shown = document.querySelector('[js-hb-main-product]').dataset;
        const current = shown.templateSuffix;
        const target = withParams(url);
        requested = target.pathname;

        // Wait for any in-flight full-page fetch so a cheaper sections request can be used instead.
        await learning.get(suffix);
        const request = requestUrl(target, suffix);
        const text = await fetchText(request);
        if (call !== latest) return;
        const doc = parse(text, request === target.href);
        remember(doc);
        const fresh = doc.querySelector(mainSel);
        const product = fresh?.querySelector('[js-hb-main-product]');
        if (product?.dataset.url !== target.pathname) throw new Error('unexpected product');

        // Swap the DOM, then keep body classes in sync
        const scrollY = window.scrollY;
        if (push) history.pushState(null, '', target.href);
        suffixes.set(target.pathname, product.dataset.templateSuffix);
        document.body.classList.replace(`template-${current}`, `template-${product.dataset.templateSuffix}`);
        document.body.classList.replace(shown.url.split('/').pop(), target.pathname.split('/').pop());

        // Keep the already-rendered Yotpo star widgets in place of the new section's unrendered ones
        const stars = document.querySelectorAll(`${mainSel} .yotpo-widget-instance`);
        document.querySelector(mainSel).replaceWith(fresh);
        fresh.querySelectorAll('.yotpo-widget-instance').forEach((el, i) => stars[i] && el.replaceWith(stars[i]));
        colorSections.forEach(t => {
            const from = findColorSection(doc, t);
            const to = findColorSection(document, t);
            if (from && to) to.replaceChildren(...from.childNodes);
        });
        // Re-run the theme and third-party initializers that normally run on page load.
        await startEko(fresh);
        window.Shopify.theme.sections.registered.product(fresh.querySelector('[data-section-type="product"]'));
        if (typeof timesactScriptNew === 'function' && typeof jQuery191 !== 'undefined') timesactScriptNew(jQuery191);
        window.yotpo?.initWidgets();
        document.dispatchEvent(new CustomEvent('size-guide:init'));
        document.dispatchEvent(new CustomEvent('mainProductSectionMarquee:init'));
        const title = fresh.querySelector('[js-page-title]');
        if (title?.dataset.pageTitle) document.title = title.dataset.pageTitle;
        window.scrollTo(0, scrollY);
    }

    // Called by the swatch click handler in main-product.liquid. Marks the swatch active immediately,
    // then falls back to a normal navigation if the in-place switch fails
    window.hbSwitchColor = (url, anchor) => {
        document.querySelector('.stitcher-item.active')?.classList.remove('active');
        anchor.querySelector('.stitcher-item')?.classList.add('active');
        const color = anchor.querySelector('[js-stitcher-item]')?.dataset.selectedColor;
        const status = document.querySelector('[data-style-status]');
        if (color && status) status.textContent = color;
        switchColor(url, anchor.dataset.templateSuffix, true).catch(() => { window.location.href = url; });
    };

    // Back/forward: switch to the product in the URL unless it's already the one shown or loading
    window.addEventListener('popstate', () => {
        if ((requested ?? landing?.dataset.url) === location.pathname) return;
        switchColor(location.href, suffixes.get(location.pathname), false).catch(() => location.reload());
    });
})();
